import { render } from "./Oberon.vue?vue&type=template&id=b669f1d0&scoped=true&ts=true"
import script from "./Oberon.vue?vue&type=script&lang=ts"
export * from "./Oberon.vue?vue&type=script&lang=ts"

import "./Oberon.vue?vue&type=style&index=0&id=b669f1d0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b669f1d0"]])

export default __exports__